import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { Sparkles } from "lucide-react";
import { Badge } from "@/components/ui/badge";

const DEFAULT_PRODUCT_IMAGE = "https://nivilabs.bionivid.com/resources/images/assest.static.default.product.png";

export default function ProductCard({ product }) {
  const { add } = useCart();
  const img = product.images?.[0] || DEFAULT_PRODUCT_IMAGE;
  const objectProperty = img === DEFAULT_PRODUCT_IMAGE ? "cover" : "contain";
  return (
    <div className="group bg-white rounded-xl border border-gray-100 overflow-hidden hover:border-primary/30 hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] transition-all flex flex-col" data-testid={`product-card-${product.id}`}>
      <Link to={`/product/${product.id}`} className="aspect-[4/3] bg-muted/30 overflow-hidden block">
        <img src={img} alt={product.name} className={`w-full h-full object-${objectProperty} group-hover:scale-105 transition-transform duration-500`} loading="lazy" />
      </Link>
      <div className="p-4 flex-1 flex flex-col">
        <div className="flex items-center gap-1.5 flex-wrap mb-2">
          {product.new_arrival && (
            <Badge className="bg-secondary/10 text-secondary border-0 text-[10px] font-semibold">
              <Sparkles className="w-3 h-3 mr-1" />NEW
            </Badge>
          )}
          {product.featured && (
            <Badge className="bg-accent/30 text-accent-foreground border-0 text-[10px] font-semibold">FEATURED</Badge>
          )}
          {/* <span className={`ml-auto text-[10px] font-medium ${product.availability === "in_stock" ? "text-primary" : "text-destructive"}`}>
            {product.availability === "in_stock" ? "● In stock" : "● Out of stock"}
          </span> */}
        </div>
        <Link to={`/product/${product.id}`} className="font-medium text-sm leading-snug text-foreground line-clamp-2 hover:text-primary">
          {product.name}
        </Link>
        {/* <div className="text-[11px] text-muted-foreground mt-1 font-mono">Catalog No: {product.catalogNumber}</div> */}
        <p className="text-xs text-muted-foreground mt-2 line-clamp-2 flex-1">{product.description}</p>
      </div>
    </div>
  );
}
